<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="PARAMETRIZACIÓN CONTABLE" key="1">
          <g-master name="coc"
                    ref="master"
                    @params="paramsTable"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="80%"
                    @action="masterAction"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-tabs default-active-key="1">
                  <a-tab-pane key="1" force-render>
                  <span slot="tab">
                    <a-icon type="apartment"/>
                    Parametrización
                  </span>
                    <a-col v-bind="colOptions">
                      <g-lookup endpoint="coc"
                                :label="$t('Concepto')"
                                :formItemConfig="fiOptions"
                                :decorator="['id_coc', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                ref="concepto"
                      >
                      </g-lookup>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Coc. Dest')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['coc_dst', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                  :params="estado_sn">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Condición')">
                        <a-input
                          v-decorator="['condicion', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Naturaleza')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['natu', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                  :params="id_h_param_type">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Origen')">
                        <a-input
                          v-decorator="['origen', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Tipo de pago')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['tpay', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                  :params="tipo_pago">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Monto')">
                        <a-input
                          v-decorator="['ammount', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Monto L.')">
                        <a-input
                          v-decorator="['ammount_l', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Tercero por defecto')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['tercero_default', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                  :params="estado_sn">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Número tercero')">
                        <a-input
                          v-decorator="['num_tercero', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Nombre tercero')">
                        <a-input
                          v-decorator="['nombre_terc', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Dígito')">
                        <a-input
                          v-decorator="['digito', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="company"
                                  :label="$t('Compañía')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['company', { rules: [{ required: false }] }]">
                      </g-dropdown>
                    </a-col>
                  </a-tab-pane>
                  <a-tab-pane key="2" force-render>
                  <span slot="tab">
                    <a-icon type="number"/>
                    Detalle
                  </span>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C1')">
                        <a-input
                          v-decorator="['c1', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C2')">
                        <a-input
                          v-decorator="['c2', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C3')">
                        <a-input
                          v-decorator="['c3', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C4')">
                        <a-input
                          v-decorator="['c4', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C5')">
                        <a-input
                          v-decorator="['c5', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C6')">
                        <a-input
                          v-decorator="['c6', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C7')">
                        <a-input
                          v-decorator="['c7', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C8')">
                        <a-input
                          v-decorator="['c8', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C9')">
                        <a-input
                          v-decorator="['c9', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C10')">
                        <a-input
                          v-decorator="['c10', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C11')">
                        <a-input
                          v-decorator="['c11', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('C12')">
                        <a-input
                          v-decorator="['c12', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                  </a-tab-pane>
                </a-tabs>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" force-render>
                  <span slot="tab">
                    <a-icon type="apartment"/>
                    Parametrización
                  </span>
        <g-descriptions-detail v-if="detalle" :detalle="detalle" :valoresExpandidos="valoresExpandidos">
        </g-descriptions-detail>
      </a-tab-pane>
      <a-tab-pane key="2" force-render>
                  <span slot="tab">
                    <a-icon type="number"/>
                    Detalle
                  </span>
        <g-descriptions-detail v-if="detalle" :detalle="detalle" :valoresExpandidos="valoresExpandidosDet"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        valoresExpandidos: [
          {label: '#', column: 'id'},
          {label: 'ID Concepto', column: 'id_coc'},
          {label: 'Concepto', column: 'coc_name'},
          {label: 'Condición', column: 'condicion'},
          {label: 'Origen', column: 'origen'},
          {label: 'Monto', column: 'ammount'},
          {label: 'Monto L.', column: 'ammount_l'},
          {label: 'Tercero por defecto', column: 'tercero_default_desc'},
          {label: 'Nom. de tercero', column: 'nombre_terc'},
          {label: 'Núm. de tercero', column: 'num_tercero'},
          {label: 'Coc destino', column: 'coc_dst_desc'},
          {label: 'Naturaleza', column: 'proceso'},
          {label: 'Tipo de pago', column: 'tipo_pago'},
          {label: 'Dígito', column: 'digito'},
          {label: 'Compañía', column: 'company_name'}
        ],
        valoresExpandidosDet: [
          {label: this.$t('C1'), column: 'c1'},
          {label: this.$t('C2'), column: 'c2'},
          {label: this.$t('C3'), column: 'c3'},
          {label: this.$t('C4'), column: 'c4'},
          {label: this.$t('C5'), column: 'c5'},
          {label: this.$t('C6'), column: 'c6'},
          {label: this.$t('C7'), column: 'c7'},
          {label: this.$t('C8'), column: 'c8'},
          {label: this.$t('C9'), column: 'c9'},
          {label: this.$t('C10'), column: 'c10'},
          {label: this.$t('C11'), column: 'c11'},
          {label: this.$t('C12'), column: 'c12'}
        ],
        estado_sn: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        id_h_param_type: {
          h_lookup_type: 'TIPO_NATURALEZA',
          use_code: true
        },
        full: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        tipo_pago: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          endpoint: 'coc_ctb',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Compañía', dataIndex: 'company_name', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Coc destino', dataIndex: 'coc_dst_desc', sorter: true},
              {title: 'Condición', dataIndex: 'condicion', sorter: true},
              {title: 'Naturaleza', dataIndex: 'proceso', sorter: true},
              {title: 'Origen', dataIndex: 'origen', sorter: true},
              {title: 'Tipo de pago', dataIndex: 'tipo_pago', sorter: true},
              {title: 'Núm. de tercero', dataIndex: 'num_tercero', sorter: true},
              {title: 'Nom. de tercero', dataIndex: 'nombre_terc', sorter: true},
              {title: 'Dígito', dataIndex: 'digito', sorter: true},
              {title: this.$t('C1'), dataIndex: 'c1', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_coc'},
            {name: 'coc_dst'},
            {name: 'condicion'},
            {name: 'coc_natu'},
            {name: 'origen'},
            {name: 'tpay'},
            {name: 'natu'},
            {name: 'ammount'},
            {name: 'ammount_l'},
            {name: 'tercero_default'},
            {name: 'num_tercero'},
            {name: 'nombre_terc'},
            {name: 'digito'},
            {name: 'company'},
            {name: 'c1'},
            {name: 'c2'},
            {name: 'c3'},
            {name: 'c4'},
            {name: 'c5'},
            {name: 'c6'},
            {name: 'c7'},
            {name: 'c8'},
            {name: 'c9'},
            {name: 'c10'},
            {name: 'c11'},
            {name: 'c12'}
          ]
        },
        endpointExcel: 'coc_ctb_/downloadExcel',
        fileNameExcel: 'ConceptosContables',
        paramsT: {},
        COLUMNS_EXCEL: [
          {title: '#', dataIndex: 'id'},
          {title: 'ID Concepto', dataIndex: 'id_coc'},
          {title: 'Compañía', dataIndex: 'company_name'},
          {title: 'Concepto', dataIndex: 'coc_name'},
          {title: 'Condición', dataIndex: 'condicion'},
          {title: 'Origen', dataIndex: 'origen'},
          {title: 'Monto', dataIndex: 'ammount'},
          {title: 'Monto L.', dataIndex: 'ammount_l'},
          {title: 'Tercero por defecto', dataIndex: 'tercero_default_desc'},
          {title: 'Nom. de tercero', dataIndex: 'nombre_terc'},
          {title: 'Núm. de tercero', dataIndex: 'num_tercero'},
          {title: 'Coc destino', dataIndex: 'coc_dst_desc'},
          {title: 'Naturaleza', dataIndex: 'proceso'},
          {title: 'Tipo de pago', dataIndex: 'tipo_pago'},
          {title: 'Dígito', dataIndex: 'digito'},
          {title: this.$t('C1'), dataIndex: 'c1'},
          {title: this.$t('C2'), dataIndex: 'c2'},
          {title: this.$t('C3'), dataIndex: 'c3'},
          {title: this.$t('C4'), dataIndex: 'c4'},
          {title: this.$t('C5'), dataIndex: 'c5'},
          {title: this.$t('C6'), dataIndex: 'c6'},
          {title: this.$t('C7'), dataIndex: 'c7'},
          {title: this.$t('C8'), dataIndex: 'c8'},
          {title: this.$t('C9'), dataIndex: 'c9'},
          {title: this.$t('C10'), dataIndex: 'c10'},
          {title: this.$t('C11'), dataIndex: 'c11'},
          {title: this.$t('C12'), dataIndex: 'c12'}
        ]
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.id_coc)) {
              this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      detalle () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.COLUMNS_EXCEL}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/CocCtb/CocCtb.vue